import { SupportedCurrencyCode } from '../../../Types/generated-types'
import { ActiveLocale, isActiveLocale } from '../../../Types/Location'

const currenciesByCountry: Record<ActiveLocale, SupportedCurrencyCode> = {
  GB: SupportedCurrencyCode.Gbp,
  US: SupportedCurrencyCode.Usd,
  AU: SupportedCurrencyCode.Aud,
  IE: SupportedCurrencyCode.Eur,
}

const getCurrencyByCountry = (country?: string | null): SupportedCurrencyCode => {
  if (isActiveLocale(country)) return currenciesByCountry[country]

  return SupportedCurrencyCode.Eur
}

export default getCurrencyByCountry
